import { getBasicContentSchema } from '@/lib/zy-tiptap-utils';
import { TableCellNode } from '../../tiptap-node/table-node/extensions/table-node-extension';
import { createTableCellNodeView } from './table-cell-node-view';

import { parseImportedWidth } from './utils';

export const ZyTableCellHeadless = TableCellNode.extend({
    allowGapCursor: false,
    content: function () {
        return getBasicContentSchema({
            requireAtLeastOneNode: true,
            additionalContentTypes: ['zydefnBlock', 'imageUpload'],
            restrictedContentTypes: ['zyInlineEnum'],
        });
    },

    addAttributes() {
        return {
            ...this.parent?.(),
            importedWidth: {
                default: null,
                parseHTML: (element: HTMLElement) => parseImportedWidth(element),
                renderHTML: attributes => {
                    // Use the importedWidth attribute if it is set unless the colwidth attribute is set
                    if (attributes.importedWidth == null || attributes.colwidth != null) {
                        return {};
                    }
                    return { width: `${attributes.importedWidth}%` };
                },
            },
        };
    },
});

export const ZyTableCell = ZyTableCellHeadless.extend({
    addNodeView() {
        return createTableCellNodeView('td');
    },
});
